import {baseURL} from "../Axios/Axios";

export const BASE_URL = baseURL;
export const SHOP_NAME = localStorage.storeName;

export const urls = {
    home: {
        productCategoryStore: BASE_URL + `/productCategoryStore/${SHOP_NAME}`,
        Banner: BASE_URL + `/store/${SHOP_NAME}`,
        Amazing: BASE_URL + `/productStore/${SHOP_NAME}/report`,
        Footer: BASE_URL + `/store/${SHOP_NAME}`,
        productsCategory: BASE_URL + `/productCategoryStore/${SHOP_NAME}`,
        contactUs: BASE_URL + `/contactToUs/${SHOP_NAME}`,
    },
    Product: {
        item: BASE_URL + `/productStore/${SHOP_NAME}`,
        listComemnts: BASE_URL + `/storeProductComment/${SHOP_NAME}/relatedList`,
        relatedData: BASE_URL + `/productStore/${SHOP_NAME}/relatedList`,
    },
    aboutUs: {
        data: BASE_URL + `/storeAboutUs/${SHOP_NAME}`,
    },
    faq: {
        categorydata: BASE_URL + `/storeFrequentlyQuestionCategory/${SHOP_NAME}`,
        mostrequsted: BASE_URL + `/storeFrequentlyQuestion/${SHOP_NAME}`,
    },
    login: {
        user: BASE_URL + `/storeUser/${SHOP_NAME}`,
    },
    Bag: {
        addtocart: BASE_URL + `/storeCart/${SHOP_NAME}`,
        cartdetails: BASE_URL + `/storeUserComment/${SHOP_NAME}`,
    },
};
